import emailjs from '@emailjs/browser';

emailjs.init("BIPsjHpzPymTldPwr");

/**
 * Sends a confirmation email to the customer for their delivery order.
 *
 * @param {Object} order - Order details
 * @param {string} order.userName - Customer display name
 * @param {string} order.userEmail - Customer email
 * @param {Array}  order.dishes - List of dishes (each with dishName, count, specialRequest)
 * @param {string} order.deliveryAddress - Full delivery address
 * @param {string} order.paymentMethod - "cash" or "card"
 * @param {number} order.subtotal - Order subtotal
 * @param {number} order.serviceFee - Service fee
 * @param {number} order.totalAmount - Total (subtotal + serviceFee)
 */
export async function sendCheckoutEmail(order) {
  try {
    // Format the list of dishes into a readable string
    const dishList = order.dishes
      .map(item =>
        `${item.dishName} x${item.count}${item.specialRequest && item.specialRequest !== "none"
          ? ` (${item.specialRequest})`
          : ""
        }`
      )
      .join('\n');

    // Prepare parameters for your EmailJS template
    const templateParams = {
      user_name: order.userName || order.userEmail?.split('@')[0] || 'Customer',
      created_at: new Date().toLocaleString(),
      delivery_address: order.deliveryAddress,
      dish_list: dishList,
      payment_method: order.paymentMethod === 'cash' ? 'Cash on Delivery' : 'Card Payment',
      subtotal: order.subtotal.toFixed(2),
      service_fee: order.serviceFee.toFixed(2),
      total_amount: order.totalAmount.toFixed(2),
      email: order.userEmail, // recipient
    };

    await emailjs.send(
      "service_jhqf5ks",  // EmailJS Service ID
      "template_xxpqqof", // EmailJS Template ID for delivery orders
      templateParams
    );
    console.log("Confirmation email sent successfully");
  } catch (error) {
    console.error("Error sending confirmation email:", error);
  }
}